import {
  Banana, ChartArea, Columns3Cog, Rocket, Lightbulb, TrendingUp,
  Users,
  ClipboardCheck,
  Trophy,
  Info,
  Network,
  LucideIcon
} from "lucide-react";

// Acounting Page
const servicesfaqs = [
  {
    question: "What accounting and bookkeeping services does Seternity provide?",
    answer:
      "Seternity provides end-to-end accounting and bookkeeping services including transaction processing, bank and credit card reconciliations, accounts payable and receivable management, payroll support, and periodic financial reporting.",
  },
  {
    question: "Who are these accounting and bookkeeping services designed for?",
    answer:
      "Our services are designed for startups, small and mid-sized businesses, and global companies seeking reliable, scalable, and cost-efficient accounting support.",
  },
  {
    question: "How does Seternity engage with accounting and bookkeeping clients?",
    answer:
      "We operate as an extension of our clients’ finance teams through a dedicated analyst or team model, typically delivered via monthly retainers aligned with transaction volume, complexity, and reporting needs.",
  },
  {
    question: "What accounting platforms and tools do you work with?",
    answer:
      "Our team works with leading cloud-based accounting platforms such as QuickBooks, Xero, Zoho Books, and other client-preferred systems.",
  },
  {
    question: "What makes Seternity different from traditional accounting service providers?",
    answer:
      "Seternity combines cost-efficient global delivery with a dedicated team model, ensuring consistent support, faster turnaround times, and greater control compared to transactional or ad-hoc accounting providers.",
  },
  {
    question: "Can you support multi-entity or international accounting requirements?",
    answer:
      "Yes, we support multi-entity structures, international operations, and consolidated reporting, ensuring standardized processes across entities and geographies",
  },
  {
    question: "How do you ensure accuracy, compliance, and quality of work?",
    answer:
      "We follow structured accounting processes, regular reconciliations, internal quality reviews, and best-practice controls to ensure accuracy, consistency, and compliance with applicable standards",
  },
  {
    question: "How is pricing structured for accounting and bookkeeping services?",
    answer:
      "Pricing is typically structured on a monthly retainer basis, offering a cost-effective alternative to in-house teams and traditional service providers while maintaining enterprise-grade delivery.",
  },
  {
    question: "How do you ensure data security and confidentiality?",
    answer:
      "We follow enterprise-grade data security and confidentiality protocols, including NDAs, controlled system access, and secure data handling practices aligned with client requirements",
  },
  {
    question: "How does Seternity deliver cost efficiencies compared to traditional providers?",
    answer:
      "Seternity leverages a global delivery model and a dedicated analyst or team structure to help clients achieve meaningful cost efficiencies while maintaining enterprise-grade quality, controls, and service continuity.",
  },
  {
    question: "What does the onboarding and transition process look like?",
    answer:
      "Our onboarding process is structured and efficient. We work closely with clients to understand existing processes, transition data securely, and ensure continuity with minimal disruption.",
  },
  {
    question: "How quickly can services be initiated?",
    answer:
      "Engagements can typically be initiated within a short timeframe once scope, access, and timelines are aligned, allowing clients to scale support quickly.",
  },
  {
    question: "How often will we receive financial reports and updates?",
    answer:
      "Reporting frequency is customized based on client needs and can include monthly financial statements, periodic reviews, and ongoing communication with the assigned team.",
  },
  {
    question: "What month-end and periodic reports does Seternity provide?",
    answer:
      "Seternity provides structured month-end reporting including income statements, balance sheets, cash flow statements, and supporting schedules, tailored to client reporting requirements.",
  },
  {
    question: "Can Seternity customize reports based on management or investor needs?",
    answer:
      "Yes, reporting can be customized to include management dashboards, variance analysis, KPI summaries, and other insights required by founders, management teams, or investors.",
  },
  {
    question: "How does Seternity ensure timely month-end close and reporting?",
    answer:
      "We follow standardized month-end close processes, clear timelines, and review mechanisms to ensure accurate and timely delivery of financial reports.",
  },
];

// Acounting Page
const AccHero = {
  subtitle: "Simple Accounting & Bookkeeping Solutions",
  title: "Reliable Accounting & Bookkeeping for Growing Businesses.",
  description: "We manage day-to-day bookkeeping, reconciliations, financial reporting, and system setup to ensure your books are accurate, compliant, and decision ready. Whether you are scaling operations or preparing for investors, we provide dependable financial infrastructure that grows with you.",
  button: "Book A Call",
  button2: "Explore Our Services",
  ctaUrl: "/contact",
  ctaUrl2: "#services",
  image: "/images/accounting-hero.png",
  imageText: "Strong businesses rely on accurate financial records and disciplined accounting processes.",
  subImage: "/images/accounting-cards.png",
  topCard: " We partner with startups, SMEs, and enterprises to simplify complex financial challenges. Our approach is transparent, data-driven, and built for long-term growth.",
  card1Title: "Financial Clarity Without the Overhead",
  card1Desc: "Reliable bookkeeping and accounting support designed to keep financial records accurate, compliant, and ready for decision-making.",
  card2Title: "Built for Growing Businesses",
  card2Desc: "Our accounting workflows ensure transactions are recorded accurately, reconciled consistently, and reported clearly.",
};

// data/pricingfaqs.js
const pricingfaqs = [
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
  {
    question: "",
    answer:
      "",
  },
];

const stats = [
  {
    label: "Production Precision",
    value: "92%",
  },
  {
    label: "Material Consistency",
    value: "87%",
  },
  {
    label: "Process Stability",
    value: "95%",
  },
  {
    label: "On-Time Delivery",
    value: "90%",
  },
];

// src/lib/content.js

const pricingPlans = [
  {
    key: "free",
    name: "Free Plan",
    description: "Perfect for small businesses starting their financial journey.",
    emails: "15 Emails in total",
    price: "Free",
    highlight: true,
    button: {
      label: "Get Started",
      href: "/contact", // future link
      variant: "secondary",
    },
    features: [
      "Free for use",
      "15 emails total",
      "Basic email delivery",
      "Standard support",
    ],
  },
  {
    key: "starter",
    name: "Starter Plan",
    description: "Ideal for growing businesses seeking advanced financial insights.",
    emails: "100 Emails per month",
    price: "$14.99/month",
    highlight: false,
    button: {
      label: "Get Started",
      href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=LJGMNRAX6M48A", // future link
      variant: "secondary",
    },
    features: [
      "Email ID count includes profiles",
      "Unused emails expire monthly",
      "Emails are not carried forward",
      "Unlimited users",
    ],
  },
  {
    key: "professional",
    name: "Professional Plan",
    description: "Designed for large organizations with complex financial needs.",
    emails: "500 Emails per month",
    price: "$29.99/month",
    highlight: true,
    button: {
      label: "Get Started",
      href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=VSJLYHJE8VHPU", // future link
      variant: "secondary",
    },
    features: [
      "500 Email IDs per month",
      "Advanced reporting",
      "Priority delivery",
      "Dedicated consultant",
    ],
  },
  {
    key: "growth",
    name: "Growth Plan",
    description: "For teams scaling fast with increasing communication needs.",
    emails: "1,000 Emails per month",
    price: "$49.99/month",
    highlight: false,
    button: {
      label: "Get Started",
      href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=UT2ZKYK3NW8FN", // future link
      variant: "secondary",
    },
    features: [
      "Comprehensive financial planning",
      "Portfolio review",
      "Quarterly consultations",
      "Email support",
    ],
  },
  {
    key: "business",
    name: "Business Plan",
    description: "Established businesses requiring deeper financial strategy.",
    emails: "1,500 Emails per month",
    price: "$69.99/month",
    highlight: true,
    button: {
      label: "Get Started",
      href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=BDMKMA4UN275J", // future link
      variant: "secondary",
    },
    features: [
      "Advanced financial planning",
      "Risk & compliance review",
      "Dedicated advisor",
      "Priority support",
    ],
  },
  {
    key: "enterprise",
    name: "Enterprise Plan",
    description: "Custom solutions for enterprises with complex requirements.",
    emails: "3,000 Emails per month",
    price: "$119.99/month",
    highlight: false,
    button: {
      label: "Get Started",
      href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=M74GMECRJDVVA", // future link
      variant: "secondary",
    },
    features: [
      "Custom integrations",
      "Dedicated account manager",
      "SLA-backed support",
      "Unlimited scalability",
    ],
  },
];


const navItems = [
  { id: 2, label: "About", href: "/about-us" },
  { id: 3, label: "Capabilities", href: "/" },
  { id: 4, label: "Client Segments", href: "/" },
  { id: 1, label: "Careers", href: "/career" },
  { id: 5, label: "Insights", href: "/insights" },
];

const avatarImages = [
  { src: "/images/profile1.jpg", alt: "@shadcn", label: "Shadcn" },
  { src: "/images/profile2.jpg", alt: "@maxleiter", label: "Max Leiter" },
  { src: "/images/profile3.jpg", alt: "@evilrabbit", label: "Evil Rabbit" },
]

const solutions = [
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Market Segmentation Services",
    description: "Create personas, improve marketing efficiency, product fitment, customer satisfaction, and business margins."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Product Development Research",
    description: "Know our customer requirements, create a competitive edge, and find new avenues for growth."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "User Acceptance Testing (UAT) Studies",
    description: "Information on customer preferences and their perceptions."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Concept Testing",
    description: "Justify product ideas, mitigate risks, and ensure that the final product is as per customer expectation and market demand."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Competitor Analysis",
    description: "Market position, SWOT, and a strategic decision to move ahead of competition."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Ad Effectiveness",
    description: "Measure the impact of your advertising campaigns and optimize your marketing spend."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Pricing Strategy",
    description: "Optimize price and conditions and improve market position relative to competitors."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Customer Satisfaction and Experience",
    description: "Increase customer loyalty and overall satisfaction and reduce churn."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Market Entry Strategies",
    description: "Lower investment risks after validating assumptions, understand local markets, and refine approaches"
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Brand Awareness and Positioning",
    description: "Create personas, improve marketing efficiency, product fitment, customer satisfaction, and business margins."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Social and Environmental Studies",
    description: "Ecological assessments and for corporate social responsibility."
  },
  {
    icon: <Banana classNameName="w-6 h-6 text-green-600" />,
    title: "Consumer Behavior Research",
    description: "Explore what drives consumer choices with SGA’s consumer behavior research services."
  },
];

const whyUs = {
  title: "Why Choose Us",
  description: "We combine deep industry expertise with cutting-edge research methodologies to deliver actionable insights that drive business growth.",
  focusAreas: [
    {
      title: "Industry Expertise",
      description: "Deep domain knowledge across multiple sectors",
      image: "/images/profile3.jpg"
    },
    {
      title: "Data-Driven Approach",
      description: "Leveraging advanced analytics for precise insights",
      image: "/images/profile4.jpg"
    },
    {
      title: "Global Reach",
      description: "Extensive network and presence across key markets",
      image: "/images/profile1.jpg"
    },
    {
      title: "Proven Methodology",
      description: "Established frameworks for reliable results",
      image: "/images/profile2.jpg"
    }
  ],
  cards: [
    {
      icon: <ChartArea />,
      title: "End-to-End Market Analysis",
      description: "Structured analysis covering market size, demand drivers, customer behavior, and competitive dynamics—built to support real decisions."
    },
    {
      icon: <Columns3Cog />,
      title: "Research Built Around Your Business",
      description: "No off-the-shelf frameworks. Every study is designed around your objectives, constraints, and decision timelines."
    },
    {
      icon: <Rocket />,
      title: "Speed Without Compromise",
      description: "Efficient execution models that deliver insights fast, without sacrificing data quality or analytical depth."
    },
    {
      icon: <Lightbulb />,
      title: "Insights You Can Defend",
      description: "Clear, evidence-backed recommendations that hold up under leadership review and guide confident action."
    }
  ]

};

const industries = {
  title: "Industries We Serve",
  description: "Delivering tailored solutions across diverse sectors to drive growth and innovation",
  industriesCards: [
    {
      imageUrl: "/images/automotive.jpg",
      title: "Automotive",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/govt.jpg",
      title: "Government",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/manufacturing.jpg",
      title: "Manufacturing",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/tech.jpg",
      title: "Technology & IT",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/fintech.jpg",
      title: "BFSI & Fin-Tech",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/healthcare.jpg",
      title: "Healthcare",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/media.jpg",
      title: "Media & Entertainment",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/consumer.jpg",
      title: "Consumer Goods",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/pharma.jpg",
      title: "Pharmaceuticals",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
    {
      imageUrl: "/images/ecommerce.jpg",
      title: "Retail & E-Commerce",
      description: "Research-driven insights across mobility trends, electric vehicles, connected technologies, and evolving consumer expectations."
    },
  ]
};

// data/services.js
export const ACCservices = [
  {
    id: 1,
    title: "General Ledger Accounting",
    description: "Complete management of journal entries, reconciliations, and period closures to deliver accurate, compliant, and decision-ready financial data.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book-open-check-icon lucide-book-open-check text-[#4F7AC2]"><path d="M12 21V7" /><path d="m16 12 2 2 4-4" /><path d="M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1z" /></svg>,
     image: "/images/account-general-ledger.png",
  },
  {
    id: 2,
    title: "Account Reconciliation",
    description: "End-to-end reconciliation of bank statements, ledgers, and transactions to eliminate errors, prevent revenue leakage, and maintain clean financial records.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-check-icon lucide-file-check text-[#4F7AC2]"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" /><path d="M14 2v5a1 1 0 0 0 1 1h5" /><path d="m9 15 2 2 4-4" /></svg>,
    image: "/images/account-reconciliation.png",
  },
  {
    id: 3,
    title: "Financial Reporting",
    description: "Accurate monthly, quarterly, and annual preparation of financial statements, performance reports, and reconciliations to support transparency and strategic decisions.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text-icon lucide-file-text text-[#4F7AC2]"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" /><path d="M14 2v5a1 1 0 0 0 1 1h5" /><path d="M10 9H8" /><path d="M16 13H8" /><path d="M16 17H8" /></svg>,
    image: "/images/account-financial-reporting.png",
  },
  {
    id: 4,
    title: "Payroll Processing",
    description: "End-to-end payroll processing with precise calculations, tax compliance, and on-time salary payments—eliminating errors, delays, and compliance risks.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wallet-icon lucide-wallet text-[#4F7AC2]"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" /><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" /></svg>,
    image: "/images/account-payroll.png",
  },
  {
    id: 5,
    title: "Account Receivable",
    description: "End-to-end accounts receivable management including invoicing, payment follow-ups, and reconciliation to accelerate cash flow and minimize payment delays.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-notebook-pen-icon lucide-notebook-pen text-[#4F7AC2]"><path d="M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" /><path d="M2 6h4" /><path d="M2 10h4" /><path d="M2 14h4" /><path d="M2 18h4" /><path d="M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" /></svg>,
    image: "/images/account-receivable.png",
  },
  {
    id: 6,
    title: "Account Payable",
    description: "Accurate invoice processing, approval control, and on-time vendor payments with full reconciliation to eliminate errors, prevent cash leaks, and protect supplier relationships.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-receipt-text-icon lucide-receipt-text text-[#4F7AC2]"><path d="M13 16H8" /><path d="M14 8H8" /><path d="M16 12H8" /><path d="M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z" /></svg>,
    image: "/images/account-payable.png",
  },
  {
    id: 7,
    title: "FP&A & Management Reporting",
    description:
      "Strengthen reporting with budgets, forecasts, KPI dashboards, variance analysis, and monthly management reporting for better performance visibility.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#4F7AC2]"><path d="M3 3v18h18"/><path d="M7 14v4"/><path d="M12 10v8"/><path d="M17 6v12"/></svg>,
    image: "/images/fpa.png",
    href: "/contact",
  },
  {
    id: 8,
    title: "Virtual CFO Support",
    description:
       "Access senior finance guidance to improve cash flow visibility, support decision-making, and build a stronger finance function as you scale.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#4F7AC2]"><path d="M16 20V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/><path d="M12 12h.01"/><path d="M8 12h.01"/><path d="M16 12h.01"/></svg>,
    image: "/images/virtual-cfo.png",
    href: "/contact",
  },
  {
    id: 9,
    title: "Strategic Finance & Transactions",
    description:
      "Support key business decisions with financial modeling, scenario analysis, fundraising support, and structured strategic finance insight.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#4F7AC2]"><path d="m16 3 4 4-4 4"/><path d="M20 7H8a4 4 0 0 0-4 4v10"/><path d="m8 21-4-4 4-4"/><path d="M4 17h12a4 4 0 0 0 4-4V3"/></svg>,
    image: "/images/strategic-finance.png",
    href: "/contact",
  },
];

const servicesPlans = [
  {
    key: "Starter",
    name: "Starter",
    price: "Free",
    includes: "Includes:",
    description: "Early-stage and small businesses that need accurate books without complexity.",
    benefits: "For businesses with up to $100,000 in monthly expenses.",
    button: {
      label: "Get Started",
      href: "/signup",
    },
    features: [
      "Automated cash-basis bookkeeping",
      "Bank and credit card reconciliation",
      "Standard chart of accounts",
      "Monthly close",
      "Year-end financial package for tax filing",
    ],
  },
  {
    key: "Standard",
    name: "Standard",
    prestatus: "Starts at",
    price: "$49",
    perprice: "Per month",
    includes: "Includes everything in starter, plus:",
    description: "Startups and growing companies that rely on financial data to operate and raise capital.",
    benefits: "For businesses with up to $200,000 in monthly expenses.",
    button: {
      label: "Get Started",
      href: "/signup",
    },
    features: [
      "Dedicated bookkeeper",
      "Cash or accrual accounting",
      "Customized chart of accounts",
      "Financial reports delivered by 10th day",
      "Support via in-app, email, and phone",
    ],
  },
  {
    key: "Enterprise",
    name: "Enterprise",
    price: "Custom",
    perprice: "",
    includes: "Includes everything in standard, plus:",
    description: "Companies with operational complexity or advanced finance needs.",
    benefits: "For businesses with more than $200,000 in monthly expenses.",
    button: {
      label: "Contact Sales",
      href: "/contact",
    },
    features: [
      "Full accounts receivable",
      "Full accounts payable",
      "Payroll administration",
      "Direct access via email, phone, or Slack",
      "Accelerated close reports by 6th day",
    ],
  },
];


export const finderSteps = [
  {
    step: "Step 1:",
    title: "Install the Seternity Chrome Extension",
    description:
      "Download and install the Seternity Email Finder Chrome extension and log in using the credentials sent to your email.",
    image: "/images/step-1.jpg",
    bgColor: "bg-[#EAE0FF]",
    textColor: "text-[#713CDD]",
    reverse: false,
  },
  {
    step: "Step 2:",
    title: "Log in to Your Account",
    description:
      "Sign in to your Seternity account using your registered email and password to activate the extension.",
    image: "/images/step-3.png",
    bgColor: "bg-[#DCF1FF]",
    textColor: "text-[#12A2F6]",
    reverse: false,
  },
  {
    step: "Step 3:",
    title: "Open a LinkedIn Profile",
    description:
      "Visit any LinkedIn individual profile of the person whose professional email address you want to find.",
    image: "/images/emailfinder.jpg",
    bgColor: "bg-[#FDD1F4]",
    textColor: "text-[#DD3CBA]",
    reverse: true,
  },
  {
    step: "Step 4:",
    title: "View the Email Address",
    description:
      "The extension displays the email address directly inside the extension window if it is available.",
    image: "/images/step-4.png",
    bgColor: "bg-[#D0F7F5]",
    textColor: "text-[#0EA79F]",
    reverse: true,
  },
  // {
  //   step: "Step 5:",
  //   title: "Verify the addresses",
  //   description:
  //     "To keep your prospect list up-to-date, use Seternity Solutions's Email Verifier to validate your contacts.",
  //   image: "/images/retail.jpg",
  //   bgColor: "bg-[#D9D0FC]",
  //   textColor: "text-[#5C3CDD]",
  //   reverse: false,
  // },
  // {
  //   step: "Step 6:",
  //   title: "Export or manage your contacts",
  //   description:
  //     "You can export your clean, up-to-date list in formats like CSV, XLSX, or TXT or directly transfer the data to integrated platforms such as HubSpot, Pipedrive, Salesforce and more.",
  //   image: "/images/retail.jpg",
  //   bgColor: "bg-[#FEECDC]",
  //   textColor: "text-[#F68012]",
  //   reverse: false,
  // },
];


const faqs = [
  {
    question: "What inspired the formation of Seternity Solutions?",
    answer:
      " was founded to bridge the gap between rising operational demands and limited internal bandwidth within finance, research, and analytics teams. We saw organizations struggling with high costs, fragmented workflows, and inefficient scaling. Seternity was created to provide structured, scalable, and cost-efficient support through a Team-as-a-Service model that enhances output without increasing management burden."
  },
  {
    question: "Who does Seternity Solutions work with?",
    answer:
      "We partner with private equity firms, investment banks, venture capital funds, institutional research teams, asset managers, and growth-focused businesses. Our clients range from boutique advisory firms to global financial institutions seeking reliable, scalable execution support."
  },
  {
    question: "What services does Seternity Solutions provide?",
    answer:
      "We deliver accounting and bookkeeping, capital markets research, investment research, market research, business development support, and data analytics outsourcing. Our services span the full operational lifecycle—from transaction support and financial modeling to portfolio monitoring and strategic reporting."
  },
  {
    question: "What values guide Seternity’s approach?",
    answer:
      "Our approach is built on precision, accountability, confidentiality, and measurable performance impact. We prioritize structured processes, disciplined analytics, ethical standards, and long-term partnership over short-term outsourcing transactions."
  },
  {
    question: "Why should organizations choose Seternity as their strategic partner?",
    answer:
      "We combine domain expertise with technology-enabled workflows and global delivery efficiency. Clients benefit from reduced overhead, faster turnaround times, scalable capacity, and institutional-grade outputs—all delivered with minimal oversight requirements."
  },
  {
    question: "How is Seternity different from a traditional outsourcing firm?",
    answer:
      "Unlike conventional outsourcing providers focused primarily on cost arbitrage, Seternity integrates deeply with client teams, aligns to investment and operational objectives, and delivers decision-ready work products. We emphasize structured execution, sector expertise, and long-term partnership rather than transactional support."
  }
]

const locations = [
  {
    id: 1,
    type: 'office',
    name: 'Seternity HQ',
    coordinates: [55.2708, 25.2048], // lng, lat
  },
  {
    id: 2,
    type: 'client',
    name: 'Client – USA',
    coordinates: [-74.006, 40.7128],
  },
  {
    id: 3,
    type: 'client',
    name: 'Client – Europe',
    coordinates: [2.3522, 48.8566],
  },
];

// Blog Page 
const BlogHero = {
  subText: "Financial Mastery",
  title: "The Finance Chronicles",
  description: "In-depth insights into market trends, investment strategies, and the future of wealth management.",
  stats: [
    {
      value: "15+",
      description: "Articles"
    },
    {
      value: "Weekly",
      description: "Updates"
    },
    {
      value: "1K+",
      description: "Readers"
    },
  ]
}

// Career Page
const CareerHeroContent = {
  subText: "Amazing Culture",
  highlightTitle: "Careers",
  title: "at Seternity Solutions",
  description: "Join us in building a smarter, more efficient future for finance, research, and analytics. We're looking for innovators to help us redefine the industry.",
  button: "See open roles",
  buttonUrl: "#jobs",
  imageUrl: "/images/careers-hero.png"
}

const CareerStatsContent = [
  {
    value: "5+",
    label: "Service Lines",
    aria: "More than five service lines",
  },
  {
    value: "50+",
    label: "Global Clients",
    aria: "More than fifty global clients",
  },
  {
    value: "100+",
    label: "Projects Delivered",
    aria: "More than one hundred projects delivered",
  },
];

const CareerBenefits = {
  title: "Employee Benefits & Perks",
  benefits: [
    {
      icon: TrendingUp,
      title: "Professional Growth",
      description: "Unlock your potential with tailored career paths and learning opportunities."
    },
    {
      icon: Users,
      title: "Innovative Work Culture",
      description: "Collaborate in a fast-paced environment that values fresh ideas."
    },
    {
      icon: ClipboardCheck,
      title: "Work-Life Balance",
      description: "Flexible schedules designed to keep you refreshed and motivated."
    },
    {
      icon: Trophy,
      title: "Recognition & Rewards",
      description: "We celebrate your wins with competitive bonuses and internal awards."
    },
    {
      icon: Info,
      title: "Meaningful Impact",
      description: "Your work directly contributes to products used by millions globally."
    },
    {
      icon: Network,
      title: "Supportive Leadership",
      description: "Guidance from mentors who are invested in your personal success."
    },
  ]
};


export {
  locations,
  faqs,
  stats,
  pricingPlans,
  pricingfaqs,
  ACCservices,
  servicesPlans,
  servicesfaqs,
  navItems,
  avatarImages,
  solutions,
  finderSteps,
  industries,
  whyUs,
  AccHero,
  BlogHero,
  CareerHeroContent,
  CareerStatsContent,
  CareerBenefits
}
